import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function IletisimPage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const contactInfo = [
    {
      icon: 'ri-map-pin-line',
      title: 'Adres',
      content: 'Kemalpaşa, Cumhuriyet Cd. No:52, 06780 Elmadağ/Ankara',
      link: 'https://maps.google.com/?q=Kemalpaşa,+Cumhuriyet+Cd.+No:52,+06780+Elmadağ/Ankara'
    },
    {
      icon: 'ri-phone-line',
      title: 'Telefon',
      content: '0533 617 82 75',
      link: 'tel:+905336178275'
    },
    {
      icon: 'ri-mail-line',
      title: 'E-posta',
      content: 'info@ucoklarperde.com',
      link: 'mailto:info@ucoklarperde.com'
    },
    {
      icon: 'ri-time-line',
      title: 'Çalışma Saatleri',
      content: 'Pazartesi - Cumartesi: 09:00 - 19:00',
      link: null
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-white shadow-sm'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="flex items-center">
              <img src="https://static.readdy.ai/image/aaba9897d2facfbc7f1204630a4017ac/2f42915d313b6b9ad9e1e568a266df73.png" alt="Üçoklar Perde" className="h-16 w-auto" />
            </Link>
            
            <div className="hidden lg:flex items-center space-x-8">
              <Link to="/" className="text-sm font-medium text-gray-900 hover:text-amber-600 transition-colors whitespace-nowrap">Ana Sayfa</Link>
              <Link to="/urunler" className="text-sm font-medium text-gray-900 hover:text-amber-600 transition-colors whitespace-nowrap">Ürünler</Link>
              <Link to="/hali" className="text-sm font-medium text-gray-900 hover:text-amber-600 transition-colors whitespace-nowrap">Halı Satışı</Link>
              <Link to="/ev-tekstili" className="text-sm font-medium text-gray-900 hover:text-amber-600 transition-colors whitespace-nowrap">Ev Tekstili</Link>
              <Link to="/hakkimizda" className="text-sm font-medium text-gray-900 hover:text-amber-600 transition-colors whitespace-nowrap">Hakkımızda</Link>
              <Link to="/iletisim" className="text-sm font-medium text-amber-600 transition-colors whitespace-nowrap">İletişim</Link>
            </div>

            <Link to="/iletisim" className="hidden lg:block bg-amber-700 hover:bg-amber-800 text-white px-6 py-2.5 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer">
              Teklif Al
            </Link>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-teal-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-6xl md:text-7xl font-bold text-gray-900 mb-6">İletişim</h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Sorularınız için bize ulaşın. Uzman ekibimiz size yardımcı olmaktan mutluluk duyar.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Info Cards */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-20">
            {contactInfo.map((info, index) => (
              <div key={index} className="bg-teal-50 rounded-2xl p-8 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${info.icon} text-3xl text-teal-700`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-3">{info.title}</h3>
                {info.link ? (
                  <a 
                    href={info.link} 
                    target={info.link.startsWith('http') ? '_blank' : undefined}
                    rel={info.link.startsWith('http') ? 'noopener noreferrer' : undefined}
                    className="text-gray-600 hover:text-teal-700 transition-colors cursor-pointer leading-relaxed"
                  >
                    {info.content}
                  </a>
                ) : (
                  <p className="text-gray-600 leading-relaxed">{info.content}</p>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-5xl font-bold text-gray-900 mb-4">Bizi Ziyaret Edin</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Showroomumuza gelerek ürünlerimizi yakından inceleyebilirsiniz
            </p>
          </div>

          <div className="w-full h-96 rounded-3xl overflow-hidden shadow-xl">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3058.8!2d32.9!3d40.0!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDAwJzAwLjAiTiAzMsKwNTQnMDAuMCJF!5e0!3m2!1str!2str!4v1234567890"
              width="100%" 
              height="100%" 
              style={{ border: 0 }} 
              allowFullScreen 
              loading="lazy"
              title="Üçoklar Perde Konum"
            ></iframe>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-5xl font-bold text-gray-900 mb-6">Hemen İletişime Geçin</h2>
          <p className="text-xl text-gray-600 mb-8 leading-relaxed">
            WhatsApp üzerinden bize ulaşın, size en kısa sürede dönüş yapalım.
          </p>
          <a 
            href="https://wa.me/905336178275" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-block bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-full text-lg font-medium transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line mr-2"></i>
            WhatsApp ile İletişim
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-teal-700 text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <svg className="w-full h-full" viewBox="0 0 1200 400">
            <path d="M0,200 Q300,100 600,200 T1200,200" stroke="currentColor" strokeWidth="1" fill="none"/>
            <path d="M0,220 Q300,120 600,220 T1200,220" stroke="currentColor" strokeWidth="1" fill="none"/>
          </svg>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
            <div className="lg:col-span-2">
              <img src="https://static.readdy.ai/image/aaba9897d2facfbc7f1204630a4017ac/2f42915d313b6b9ad9e1e568a266df73.png" alt="Üçoklar Perde" className="h-36 mb-6" />
              <p className="text-teal-100 mb-6 leading-relaxed">
                30 yıllık tecrübemizle evinize zarafet katıyoruz. Kaliteli ürünler ve profesyonel hizmet anlayışıyla yanınızdayız.
              </p>
              <div className="flex gap-4">
                <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-xl"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-youtube-fill text-xl"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-linkedin-fill text-xl"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Ürünler</h4>
              <ul className="space-y-3">
                <li><Link to="/urunler/plise-perde" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Plise Perde</Link></li>
                <li><Link to="/urunler/jaluzi-perde" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Jaluzi Perde</Link></li>
                <li><Link to="/urunler/tul-perde" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Tül Perde</Link></li>
                <li><Link to="/urunler/fon-perde" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Fon Perde</Link></li>
                <li><Link to="/urunler/zebra-perde" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Zebra Perde</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Ev Tekstili</h4>
              <ul className="space-y-3">
                <li><Link to="/hali" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Halı Satışı</Link></li>
                <li><Link to="/urunler/yatak-baza" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Yatak & Baza</Link></li>
                <li><Link to="/ev-tekstili" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Duvar Kağıdı</Link></li>
                <li><Link to="/ev-tekstili" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Ev Tekstili</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">İletişim</h4>
              <ul className="space-y-3">
                <li className="text-teal-100 text-sm leading-relaxed">
                  <i className="ri-map-pin-line mr-2"></i>
                  Kemalpaşa, Cumhuriyet Cd. No:52, 06780 Elmadağ/Ankara
                </li>
                <li>
                  <a href="tel:+905336178275" className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                    <i className="ri-phone-line mr-2"></i>
                    0533 617 82 75
                  </a>
                </li>
                <li>
                  <a href="mailto:info@ucoklarperde.com" className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                    <i className="ri-mail-line mr-2"></i>
                    info@ucoklarperde.com
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-teal-600 pt-8">
            <p className="text-teal-100 text-sm text-center">© 2025 Üçoklar Perde. Tüm hakları saklıdır.</p>
          </div>
        </div>
      </footer>

      {/* WhatsApp Button */}
      <a 
        href="https://wa.me/905336178275" 
        target="_blank" 
        rel="noopener noreferrer"
        className="fixed bottom-8 right-8 z-50 w-16 h-16 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center shadow-2xl transition-all hover:scale-110 cursor-pointer group"
      >
        <i className="ri-whatsapp-line text-3xl text-white"></i>
        <span className="absolute right-20 bg-gray-900 text-white px-4 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          WhatsApp ile İletişim
        </span>
      </a>
    </div>
  );
}